import React, { Component } from 'react';

export default class AckFilter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
        };
    }

    onChange = (event) => {
        const value = event.target.value === "" ? null : event.target.value;
        this.setState({ value });
        this.props.onChange(value);
    }


    render() {

        const { value } = this.state;

        return (
            <select
                onChange={this.onChange}
                style={{
                    width: "100%",
                    height: "40px",
                    fontSize: "12px"
                }}
                value={value}
            >
                <option value="">All</option>
                <option value="pending">Pending</option>
                <option value="noAnswer">No Answer</option>
                <option value="completed">Yes</option>
            </select>
        )
    }
}
